import { API_URL, getHeaders } from "../../utils/contextHelpers";
import { api, buildQuery } from "./core";

export const actualizarMarketing = api(
  "actualizarMarketing",
  (id, acepta_marketing) =>
    `${API_URL}mantenedor/usuarios/actualizar/marketing?${buildQuery({
      id,
      acepta_marketing: acepta_marketing ? 1 : 0,
    })}`,
  { method: "POST" }
);

export const getUsuariosMarketing = api(
  "getUsuariosMarketing",
  () => `${API_URL}mantenedor/usuarios/marketing`
);

export const getAceptaMarketing = api(
  "getAceptaMarketing",
  (id) =>
    `${API_URL}mantenedor/usuarios/aceptaMarketing?id=${encodeURIComponent(id)}`
);

export const descargarMarketingExcel = async () => {
  const headers = getHeaders();
  const response = await fetch(
    `${API_URL}mantenedor/usuarios/marketing/excel`,
    {
      headers,
    }
  );
  if (!response.ok) {
    let message = "Error al descargar el reporte de marketing";
    try {
      const data = await response.json();
      if (data?.mensaje) message = data.mensaje;
    } catch {
      /* ignore */
    }
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }
  return response.blob();
};
